var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaptain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 82 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11422,-529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10440,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Captain",
    transform: "matrix(1,-0,-0,1,982.047,529)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0.95,
    y: 12.163,
    width: "81px",
    height: "56px"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "81px",
    height: "56px",
    xlinkHref: "data:image/png;base64,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"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaptain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Captain.8a6acda82af74b2f6ab85b10a433ebfb.svg";